import {
  LIST_CLIENT_REQUEST,
  LIST_CLIENT_SUCCESS,
  LIST_CLIENT_FAIL,
  LIST_CLIENT_SUMMARY_REQUEST,
  LIST_CLIENT_SUMMARY_SUCCESS,
  LIST_CLIENT_SUMMARY_FAIL,
  LIST_CLIENT_PROJECT_SUMMARY_REQUEST,
  LIST_CLIENT_PROJECT_SUMMARY_SUCCESS,
  LIST_CLIENT_PROJECT_SUMMARY_FAIL,
  CREATE_CLIENT_REQUEST,
  CREATE_CLIENT_SUCCESS,
  CREATE_CLIENT_FAIL,
  DETAIL_CLIENT_REQUEST,
  DETAIL_CLIENT_SUCCESS,
  DETAIL_CLIENT_FAIL,
  UPDATE_CLIENT_REQUEST,
  UPDATE_CLIENT_SUCCESS,
  UPDATE_CLIENT_FAIL,
  DELETE_CLIENT_REQUEST,
  DELETE_CLIENT_SUCCESS,
  DELETE_CLIENT_FAIL,
  LIST_INVOICE_ADDRESS_REQUEST,
  LIST_INVOICE_ADDRESS_SUCCESS,
  LIST_INVOICE_ADDRESS_FAIL,
  CREATE_INVOICE_ADDRESS_REQUEST,
  CREATE_INVOICE_ADDRESS_SUCCESS,
  CREATE_INVOICE_ADDRESS_FAIL,
  DETAIL_INVOICE_ADDRESS_REQUEST,
  DETAIL_INVOICE_ADDRESS_SUCCESS,
  DETAIL_INVOICE_ADDRESS_FAIL,
  UPDATE_INVOICE_ADDRESS_REQUEST,
  UPDATE_INVOICE_ADDRESS_SUCCESS,
  UPDATE_INVOICE_ADDRESS_FAIL,
  DELETE_INVOICE_ADDRESS_REQUEST,
  DELETE_INVOICE_ADDRESS_SUCCESS,
  DELETE_INVOICE_ADDRESS_FAIL,
  RESET_DETAIL_INVOICE_ADDRESS,
  LIST_CLIENT_DOCUMENT_REQUEST,
  LIST_CLIENT_DOCUMENT_SUCCESS,
  LIST_CLIENT_DOCUMENT_FAIL,
  CREATE_CLIENT_DOCUMENT_REQUEST,
  CREATE_CLIENT_DOCUMENT_SUCCESS,
  CREATE_CLIENT_DOCUMENT_FAIL,
  UPDATE_CLIENT_DOCUMENT_REQUEST,
  UPDATE_CLIENT_DOCUMENT_SUCCESS,
  UPDATE_CLIENT_DOCUMENT_FAIL,
  DELETE_CLIENT_DOCUMENT_REQUEST,
  DELETE_CLIENT_DOCUMENT_SUCCESS,
  DELETE_CLIENT_DOCUMENT_FAIL,
  DOWNLOAD_CLIENT_DOCUMENT_REQUEST,
  DOWNLOAD_CLIENT_DOCUMENT_SUCCESS,
  DOWNLOAD_CLIENT_DOCUMENT_FAIL,
  LIST_CLIENT_DOCUMENT_CLASSIFICATION_REQUEST,
  LIST_CLIENT_DOCUMENT_CLASSIFICATION_SUCCESS,
  LIST_CLIENT_DOCUMENT_CLASSIFICATION_FAIL
} from '../../constants/clients'

const initialState = {
  loading: false,
  loadingClientProject: false,
  clients: [],
  clientsSummary: [],
  clientsProjectsSummary: [],
  loadingDetail: false,
  loadingUpdate: false,
  client: {},
  error: null,
  error: null,
  pageable: {},
  invoiceAddresses: [],
  invoiceAddressDetail: {},
  loadingInvoiceAddressDetail: false,
  loadingInvoiceAddress: false,
  generalConfigCode: [],
  clientDocuments: [],
  clientDocumentsPageable: {},
  loadingClientDocuments: false,
  loadingCreateClientDocument: false,
  loadingUpdateClientDocument: false,
  loadingDeleteClientDocument: false,
  loadingDownloadClientDocument: false,
  clientDocumentClassificationOptions: [],
  loadingClientDocumentClassification: false
}

const listClientReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_CLIENT_REQUEST:
      return { ...state, loading: true }
    case LIST_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        clients: action.payload,
        pageable: action.pageable
      }
    case LIST_CLIENT_FAIL:
      return { ...state, loading: false, error: action.payload, clients: [] }
    case LIST_CLIENT_SUMMARY_REQUEST:
      return { ...state, loading: true }
    case LIST_CLIENT_SUMMARY_SUCCESS:
      return { ...state, loading: false, clientsSummary: action.payload }
    case LIST_CLIENT_SUMMARY_FAIL:
      return { ...state, loading: false, error: action.payload }
    case "LIST_CLIENT_INVOICE_ADDRESS_REQUEST":
      return { ...state, loading: true, listClientInvoiceAddress: [] }
    case "LIST_CLIENT_INVOICE_ADDRESS_SUCCESS":
      return { ...state, loading: false, listClientInvoiceAddress: action.payload }
    case "LIST_CLIENT_INVOICE_ADDRESS_FAIL":
      return { ...state, loading: false, error: action.payload, listClientInvoiceAddress: [] }
    case "GENERAL_CONFIG_SUMMARIES_REQUEST":
      return { ...state, loading: true, generalConfigCode: [] }
    case "GENERAL_CONFIG_SUMMARIES_SUCCESS":
      return { ...state, loading: false, generalConfigCode: action.payload }
    case "GENERAL_CONFIG_SUMMARIES_FAIL":
      return { ...state, loading: false, error: action.payload, generalConfigCode: [] }
    case LIST_CLIENT_PROJECT_SUMMARY_REQUEST:
      return { ...state, loadingClientProject: true }
    case LIST_CLIENT_PROJECT_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingClientProject: false,
        clientsProjectsSummary: action.payload
      }
    case LIST_CLIENT_PROJECT_SUMMARY_FAIL:
      return { ...state, loadingClientProject: false, error: action.payload }
    case CREATE_CLIENT_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_CLIENT_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_CLIENT_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_CLIENT_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_CLIENT_SUCCESS:
      return { ...state, loadingDetail: false, client: action.payload }
    case DETAIL_CLIENT_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case UPDATE_CLIENT_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_CLIENT_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_CLIENT_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_CLIENT_REQUEST:
      return { ...state, loading: true }
    case DELETE_CLIENT_SUCCESS:
      const deletedClient = action.payload
      const deleteNewDataClients = [...state.clients]

      const deleteIndex = deleteNewDataClients.findIndex(
        (client) => client.id === deletedClient
      )
      deleteNewDataClients.splice(deleteIndex, 1)

      return { ...state, loading: false, clients: deleteNewDataClients }
    case DELETE_CLIENT_FAIL:
      return { ...state, loading: false, error: action.payload }
    case LIST_INVOICE_ADDRESS_REQUEST:
      return { ...state, loadingInvoiceAddress: true }
    case LIST_INVOICE_ADDRESS_SUCCESS:
      return {
        ...state,
        loadingInvoiceAddress: false,
        invoiceAddresses: action.payload,
        pageable: action.pageable
      }
    case LIST_INVOICE_ADDRESS_FAIL:
      return {
        ...state,
        loadingInvoiceAddress: false,
        error: action.payload,
        invoiceAddresses: []
      }
    case CREATE_INVOICE_ADDRESS_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_INVOICE_ADDRESS_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_INVOICE_ADDRESS_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_INVOICE_ADDRESS_REQUEST:
      return { ...state, loadingInvoiceAddressDetail: true }
    case DETAIL_INVOICE_ADDRESS_SUCCESS:
      return { ...state, loadingInvoiceAddressDetail: false, invoiceAddressDetail: action.payload }
    case DETAIL_INVOICE_ADDRESS_FAIL:
      return { ...state, loadingInvoiceAddressDetail: false, error: action.payload }
    case RESET_DETAIL_INVOICE_ADDRESS:
      return { ...state, invoiceAddressDetail: {}, loadingInvoiceAddressDetail: false }
    case UPDATE_INVOICE_ADDRESS_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_INVOICE_ADDRESS_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_INVOICE_ADDRESS_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_INVOICE_ADDRESS_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_INVOICE_ADDRESS_SUCCESS:
      return { ...state, loadingDelete: false }
    case DELETE_INVOICE_ADDRESS_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case LIST_CLIENT_DOCUMENT_REQUEST:
      return { ...state, loadingClientDocuments: true }
    case LIST_CLIENT_DOCUMENT_SUCCESS:
      return {
        ...state,
        loadingClientDocuments: false,
        clientDocuments: action.payload,
        clientDocumentsPageable: action.pageable
      }
    case LIST_CLIENT_DOCUMENT_FAIL:
      return {
        ...state,
        loadingClientDocuments: false,
        error: action.payload,
        clientDocuments: []
      }
    case CREATE_CLIENT_DOCUMENT_REQUEST:
      return { ...state, loadingCreateClientDocument: true }
    case CREATE_CLIENT_DOCUMENT_SUCCESS:
      return { ...state, loadingCreateClientDocument: false }
    case CREATE_CLIENT_DOCUMENT_FAIL:
      return {
        ...state,
        loadingCreateClientDocument: false,
        error: action.payload
      }
    case UPDATE_CLIENT_DOCUMENT_REQUEST:
      return { ...state, loadingUpdateClientDocument: true }
    case UPDATE_CLIENT_DOCUMENT_SUCCESS:
      return { ...state, loadingUpdateClientDocument: false }
    case UPDATE_CLIENT_DOCUMENT_FAIL:
      return {
        ...state,
        loadingUpdateClientDocument: false,
        error: action.payload
      }
    case DELETE_CLIENT_DOCUMENT_REQUEST:
      return { ...state, loadingDeleteClientDocument: true }
    case DELETE_CLIENT_DOCUMENT_SUCCESS:
      return { ...state, loadingDeleteClientDocument: false }
    case DELETE_CLIENT_DOCUMENT_FAIL:
      return {
        ...state,
        loadingDeleteClientDocument: false,
        error: action.payload
      }
    case DOWNLOAD_CLIENT_DOCUMENT_REQUEST:
      return { ...state, loadingDownloadClientDocument: true }
    case DOWNLOAD_CLIENT_DOCUMENT_SUCCESS:
      return { ...state, loadingDownloadClientDocument: false }
    case DOWNLOAD_CLIENT_DOCUMENT_FAIL:
      return {
        ...state,
        loadingDownloadClientDocument: false,
        error: action.payload
      }
    case LIST_CLIENT_DOCUMENT_CLASSIFICATION_REQUEST:
      return {
        ...state,
        loadingClientDocumentClassification: true,
        clientDocumentClassificationOptions: []
      }
    case LIST_CLIENT_DOCUMENT_CLASSIFICATION_SUCCESS:
      return {
        ...state,
        loadingClientDocumentClassification: false,
        clientDocumentClassificationOptions: action.payload
      }
    case LIST_CLIENT_DOCUMENT_CLASSIFICATION_FAIL:
      return {
        ...state,
        loadingClientDocumentClassification: false,
        error: action.payload,
        clientDocumentClassificationOptions: []
      }
    default:
      return state
  }
}

export default listClientReducer
